import React from "react";
import { z } from "zod";
import { Blade } from "../../../components/Blade";
import styled from "styled-components";
import { mixinSkins } from "../../../skins/shared/mixins/themeStyles";
import { SkinId } from "../../../skins/types";
import { SeparatorSchema, SeparatorType } from "../../../schemas/blades/Separator";
import { riotProductSkin } from "../skins/riot-product";
import { BladeContent } from "../../../components/BladeContent";
export const SeparatorContractSchema = SeparatorSchema.extend({
    type: z.literal("separator"),
});
const _Separator = ({ className, separatorType = "simple", ...props }) => {
    return (React.createElement(Blade, { className: className, "data-testid": `separator-${separatorType}`, ...props },
        React.createElement(BladeContent, { width: "small" }, separatorType == SeparatorType.ORNAMENTAL ? React.createElement("hr", { className: "ornamental" }) : React.createElement("hr", { className: "simple" }))));
};
export const SeparatorBlade = styled(_Separator) `
  ${mixinSkins({
    [SkinId.RiotProduct]: riotProductSkin,
})}
`;
//# sourceMappingURL=Separator.js.map